import { action, makeObservable, observable } from "mobx";
import type { InjectionToken } from "tsyringe";
import { hasStoredAccessToken } from "../utils/authStorage";

export enum Screens {
  Login = "Login",
  Main = "Main",
  QR = "QR",
  QRManagement = "QRManagement",
  Box = "Box",
  EditBox = "EditBox",
  Product = "Product",
  EditProduct = "EditProduct",
  AddProduct = "AddProduct",
  AddBox = "AddBox",
  Journal = "Journal",
  ProductsList = "ProductsList",
  BoxesList = "BoxesList",
  UsersManagement = "UsersManagement",
  DeletedEntities = "DeletedEntities",
  Account = "Account",
  Settings = "Settings",
}

export interface INavigationStore {
  screen: Screens;
  props: unknown;
  setScreen: (screen: Screens, props?: unknown) => void;
}

export const NAVIGATION_STORE_TOKEN = Symbol(
  "INavigationStore",
) as InjectionToken<INavigationStore>;

export class Navigation implements INavigationStore {
  constructor() {
    makeObservable(this);
  }

  @observable
  screen: Screens = hasStoredAccessToken() ? Screens.Main : Screens.Login;

  @observable
  props: unknown = null;

  @action
  setScreen = (screen: Screens, props?: unknown) => {
    if (screen !== Screens.Login && !hasStoredAccessToken()) {
      this.screen = Screens.Login;
      this.props = null;
      return;
    }

    this.screen = screen;
    this.props = props;
  };
}
